import { calculateAudienceMetrics } from '../utils/audienceMetrics.mjs';

export const normalizeAudienceData = (items) => {
  const all = {};
  const curated = {};
  const custom = {};

  if (!Array.isArray(items)) {
    return {
      all,
      curated,
      custom,
      metrics: {},
    };
  }

  for (const item of items) {
    if (!item || !item.searchQuery) {
      continue;
    }

    const subreddits = Array.isArray(item.results) ? item.results : [];
    all[item.searchQuery] = subreddits;

    if (item.isCustom === true) {
      custom[item.searchQuery] = subreddits;
    } else {
      curated[item.searchQuery] = subreddits;
    }
  }

  return {
    all,
    curated,
    custom,
    metrics: calculateAudienceMetrics(all),
  };
};

export const fetchDashboardAudienceData = async (
  baseUrl,
  fetchImpl = fetch
) => {
  const response = await fetchImpl(`${baseUrl}/v1/audiences`);
  if (!response.ok) {
    throw new Error('Failed to fetch audience data');
  }

  return normalizeAudienceData(await response.json());
};
